import SchemaPropTypes from '@get-bridge/learn-legacy-shared/dist/shared/SchemaPropTypes';
const { arrayOf, bool, number, string, shape } = SchemaPropTypes;

export default shape({
  id: string.isRequired,
  uid: string,
  firstName: string,
  lastName: string,
  fullName: string,
  sortableName: string,
  email: string,
  locale: string,
  avatarUrl: string,
  isAdministrator: bool,
  isManager: bool,
  hireDate: number,
  updatedAt: number,
  redirectUrl: string,
  roles: arrayOf(string),
  jobTitle: string,
  managerId: string,
  learnVanityUrl: string,
  name: string,
})



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/users/schemas/UserPayload.js